<template> 
  <div style="height:580px">
    <div style="padding:10px 20px;background-color:beige;border-bottom: 1px solid #ccc;">
      <h5><b>News</b></h5>
    </div>
  </div>
</template>
<script>
  
  export default {
    name: 'News',
    components: {
      
    },
    data() {
      return {
        
      }
    },
  }
</script>
<style lang="scss">
  figure {
    padding: 0;
    margin: 0;
  }

  figure figcaption {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    color: #fff;
    padding: 10px;
    background-color: black;
    opacity: 0.5;
  }
</style>
